import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import NotificationsNone from '@material-ui/icons/NotificationsNone';
import { timeAgoStepped } from 'helpers/_date-helpers';
import styles from './styles';

const useStyles = makeStyles(styles);

const RecentChangesPill = ({ latestNotifiedAt, onClick }) => {
  const classes = useStyles();

  return (
    <button type="button" className={classes.pill} onClick={onClick}>
      <NotificationsNone className={classes.pillIcon} />
      <span>Show Recent Changes</span>
      <span className={classes.pillDot}>&bull;</span>
      <span>{timeAgoStepped(latestNotifiedAt)}</span>
    </button>
  );
};

export default RecentChangesPill;
